export const Administrator_token ="token 671ee6fc8b2a7c9:b62e1ffbe52d9b7"

export const API_BASE_URL = "https://dev-erpnext.candere360.com/api/method";
